import React, { useCallback } from "react";
import { LocalFilterChipBar } from "../../../components/dataTable";
import {
  HOLDING_BY_ORDER_FILTER_COLUMNS,
  buildHoldingLocalDistinctValues,
} from "./holdingByOrderFilterUtils";

const HoldingByOrderFilterBar = ({
  orderGroups,
  tableFilterQuery,
  onFilterChange,
}) => {
  const buildDistinct = useCallback(
    (dataSource, col) => buildHoldingLocalDistinctValues(dataSource, col),
    [],
  );

  return (
    <LocalFilterChipBar
      columns={HOLDING_BY_ORDER_FILTER_COLUMNS}
      tableFilterQuery={tableFilterQuery}
      onFilterChange={onFilterChange}
      buildDistinct={buildDistinct}
      dataSource={orderGroups}
    />
  );
};

export default HoldingByOrderFilterBar;
